import React from 'react';
import { ControlLabel, FormControl } from 'react-bootstrap';
import { startFileUploadToNextcloud } from '../../../actions/nextcloudActions';
import { useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';
import { config } from './config';
import { Container, DropAreaContainer, DropAreaLabel, ImageElement, MainContainer, CloseButton, DropAreaElement } from './Atom';
import StyledIcon from '../../../../components/common/StyledIcon';
import { validateAttachmentName } from '../../../utils';

function DropArea({attachment, allAttachments, setAttachment, label, setLabel, description, setDescription, disable, dispatch, type, lastUsedAttachment }) {
  const updateAttachmentState = (type, allAttachments, data) => {
    if(type === "NOK") {
      setAttachment({["attachments"]: [allAttachments[0], data]});
    } else {
      setAttachment({["attachments"]: [data, allAttachments[1]]});
    }
  }

  const onDrop = (ev, type) => {
    if (disable) return;
    if(!type) return;
    const url = ev.dataTransfer.getData('Text');
    if(!url) return;
    updateAttachmentState(type, allAttachments, { attachmentUrl: url, attachmentOriginalName: lastUsedAttachment.fullName });
  };

  const synchronizeWithNextcloud = ev => dispatch(startFileUploadToNextcloud(ev));

  const { getRootProps, getInputProps } = useDropzone({
    disabled: disable,
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      if(!validateAttachmentName(acceptedFiles)) return;
      //get only first file from array of files
      updateAttachmentState(type, allAttachments, {
        attachmentUrl: URL.createObjectURL(acceptedFiles[0]),
        attachmentOriginalName: acceptedFiles[0].name
      });
      synchronizeWithNextcloud(acceptedFiles);
    },
  });

  const handleDelete = () => {
    if (disable) return;
    updateAttachmentState(type, allAttachments, {attachmentUrl: null, attachmentOriginalName: null});
  };

  return (
    <MainContainer
      onDrop={(e) => onDrop(e, config[type].title)}>
      <Container className="flex-row">
        <div className="inline-label">{config[type].title}</div>
        <input
          disabled={disable}
          type="checkbox"
          className="checkbox-big"
          checked={label}
          onChange={() => setLabel(!label, `label${type}`)}
        />
      </Container>
      <DropAreaContainer type={type}>
        {attachment.attachmentUrl && !disable && (<CloseButton onClick={handleDelete}>X</CloseButton>)}
        <DropAreaElement {...getRootProps()}>
          <input {...getInputProps()}/>
          {label && (<DropAreaLabel type={type}>{config[type].title}</DropAreaLabel>)}
          {!attachment.attachmentUrl && (<StyledIcon color="rgba(0,0,0,0.2)" size="ultra" glyph="edit" bsClass="glyphicon glyphicon glyphicon-edit" style={{padding: "80px"}}/>)}
          {attachment.attachmentUrl && (<ImageElement src={attachment.attachmentUrl} alt={attachment.attachmentOriginalName} />)}
        </DropAreaElement>
        {attachment.attachmentUrl && (<a href={attachment.attachmentUrl} target="_blank">Open in new tab!</a>)}
      </DropAreaContainer>
      <ControlLabel>Picture description</ControlLabel>
      <FormControl
        disabled={disable}
        componentClass="textarea"
        value={description}
        onChange={(event)=>setDescription(event.target.value, `description${type}`)}
      />
    </MainContainer>
  )
}

export default connect()(DropArea);
